export enum IconsEnum {
  HOME = 'home',
  EDIT = 'edit_button',
  ALERTS = 'alerts',
  CHECKLIST = 'checklist',
  COMPLETED_REQUEST = 'completed_request',
  CUSTOMER_DETAILS = 'customer_details',
  CUSTOMERS = 'customers',
  DASHBOARD = 'dashboard',
  DATA = 'data',
  DRIVERS = 'drivers',
  FILES = 'files',
  GRAPH = 'graph',
  MANAGE_VEHICLE = 'manage_vehicle',
  NOTIFICATIONS = 'notifications',
  NOTES = 'notes',
  MESSAGES_DARK = 'messages_dark',
  OPERATIONS = 'operations',
  PENDING = 'pending',
  QUEUE = 'queue',
  REPORTS = 'reports',
  REPORTS_TREND = 'reports_trend',
  SERVICE_REQUEST = 'service_request',
  TEAM = 'team',
  TIME = 'time',
  TREND_UP = 'trend_up',
  VENDORS = 'vendors',
  SWAP_DRIVING_APPS = 'swap_driving_apps',
}
